/**
 * Product branding constants (UI-only — backend untouched).
 * Used across nav, chat headers, empty states, metadata.
 */
export const BRAND = {
  name: 'Cognara',
  tagline: 'Expert Engine',
  full: 'Cognara — Expert Engine',
  domain: 'cognara.ai',
};

export const AGENTS = {
  sutradhar: {
    id: 'sutradhar',
    display: 'Cognara',
    role: 'Orchestrator',
    description: 'Primary engineering co-pilot. Reasons across your project context, documents, and tools.',
  },
  vidhana: {
    id: 'vidhana',
    display: 'Vidhāna',
    role: 'Planner',
    description: 'Structures multi-step plans and long-horizon workflows.',
    comingSoon: true,
  },
  karyakarta: {
    id: 'karyakarta',
    display: 'User',
    role: 'Executor',
    description: 'Carries out approved actions against connected systems.',
    comingSoon: true,
  },
};

export const DEFAULT_AGENT = AGENTS.sutradhar;
